// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DTbE","icon":"styles_icon__1NZlE"};